import { useEffect, useState } from 'react';
import styles from './BirthDateInput.module.scss';
import SelectOld from '../Base/Select/SelectOld';

export default function BirthDateInput(props) {
	const { onChange } = props;

	const [day, setDay] = useState(null);
	const [month, setMonth] = useState(null);
	const [year, setYear] = useState(null);

	const [days, setDays] = useState([]);
	const [months, setMonths] = useState([]);
	const [years, setYears] = useState([]);

	useEffect(() => {
		const tempDays = [];
		for (let i = 1; i <= 31; i++) {
			tempDays.push(i);
		}
		setDays(tempDays);
		setDay(1);

		const tempMonths = [];
		for (let i = 1; i <= 12; i++) {
			tempMonths.push(i);
		}
		setMonths(tempMonths);
		setMonth(1);

		const tempYears = [];

		const date = new Date();
		const currentYear = date.getUTCFullYear();

		for (let i = currentYear; i >= currentYear - 118; i--) {
			tempYears.push(i);
		}
		setYears(tempYears);
		setYear(currentYear);
	}, []);

	const handleChange = (key, value) => {
		const date = new Date(year, month - 1, day);

		switch (key) {
			case 'day':
				setDay(value);
				date.setDate(value);
				break;
			case 'month':
				setMonth(value);
				date.setMonth(value);
				break;
			case 'year':
				setYear(value);
				date.setUTCFullYear(value);
				break;
		}

		let tempDay = date.getDate().toString();
		tempDay = tempDay.length === 1 ? '0' + tempDay : tempDay;

		let tempMonth = (date.getUTCMonth() + 1).toString();
		tempMonth = tempMonth.length === 1 ? '0' + tempMonth : tempMonth;

		onChange?.(`${date.getUTCFullYear()}-${tempMonth}-${tempDay}`);
	};

	return (
		<div className={styles.container}>
			<div className={styles.day}>
				<SelectOld
					values={days}
					onChange={value => handleChange('day', value)}
					value={day}
				/>
			</div>
			<div className={styles.month}>
				<SelectOld
					values={months}
					onChange={value => handleChange('month', value)}
					value={month}
				/>
			</div>
			<div className={styles.year}>
				<SelectOld
					values={years}
					onChange={value => handleChange('year', value)}
					value={year}
				/>
			</div>
		</div>
	);
}
